import { render, staticRenderFns } from "./logohead.vue?vue&type=template&id=3412c5fa&scoped=true&"
import script from "./logohead.vue?vue&type=script&lang=js&"
export * from "./logohead.vue?vue&type=script&lang=js&"
import style0 from "./logohead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./logohead.vue?vue&type=style&index=1&id=3412c5fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412c5fa",
  null
  
)

export default component.exports